// This refactor alows dragable objects to work on all media devices.
// Once this is properly tested we should probably globally override Drag.
Class.refactor(Drag, {
   attach: function () {
      this.handles.addEvent('touchstart', this.bound.start);
      return Reflect.apply(this.previous, this, arguments);
   },

   detach: function () {
      this.handles.removeEvent('touchstart', this.bound.start);
      return Reflect.apply(this.previous, this, arguments);
   },

   start: function (event) {
      event.preventDefault();
      document.body.addEvents({
         touchmove: this.bound.check,
         touchend: this.bound.cancel,
      });
      Reflect.apply(this.previous, this, arguments);
   },

   check: function (event) {
      event.preventDefault();
      if (this.options.preventDefault) {
         event.preventDefault();
      }
      let distance = Math.round(
         Math.sqrt(
            Math.pow(event.page.x - this.mouse.start.x, 2) +
               Math.pow(event.page.y - this.mouse.start.y, 2)
         )
      );
      if (distance > this.options.snap) {
         this.cancel();
         this.document.addEvents({
            mousemove: this.bound.drag,
            mouseup: this.bound.stop,
         });
         document.body.addEvents({
            touchmove: this.bound.drag,
            touchend: this.bound.stop,
         });
         this.fireEvent('start', [this.element, event]).fireEvent('snap', this.element);
      }
   },

   cancel: function (event) {
      document.body.removeEvents({
         touchmove: this.bound.check,
         touchend: this.bound.cancel,
      });
      return Reflect.apply(this.previous, this, arguments);
   },

   stop: function (event) {
      document.body.removeEvents({
         touchmove: this.bound.drag,
         touchend: this.bound.stop,
      });
      return Reflect.apply(this.previous, this, arguments);
   },
});
